/** Shared sample GC portal for standalone prospect invites (not tied to a lead). */
export const SAMPLE_GC_PORTAL_SLUG = 'sample-gc-barn';
export const SAMPLE_GC_PROPOSAL_SLUG = 'jordan-sample-sample-timber-barn';
export const SAMPLE_INVITE_PURPOSE = 'sample_invite' as const;
/** Cadwork viewer tab + browser title for the sample 3D model. */
export const SAMPLE_GC_MODEL_TAB_NAME = 'SAMPLE_TIMBER_BARN (SHADED)';
export const SAMPLE_GC_MODEL_PAGE_TITLE = 'Sample Timber Barn';

export function isSampleGcPortalSlug(slug?: string | null): boolean {
  return (slug || '').trim() === SAMPLE_GC_PORTAL_SLUG;
}

export function isSampleGcProposalSlug(slug?: string | null): boolean {
  return (slug || '').trim() === SAMPLE_GC_PROPOSAL_SLUG;
}
